<template>
    <modal @close="$emit('close')">
        <div class="py-8 flex flex-col relative">
            <button class="absolute pin-t pin-r outline-none m-6 mt-3 z-40" @click="$emit('close')">
                <img class="h-4" src="@/assets/SVG/cross-partners.svg" alt="cross-partners.svg"/>
            </button>
            <div class="flex justify-center text-center flex-col  p-auto text-sm" v-if="cancel_type==='res'">
                <p class="pt-4"><span class="text-brand-light font-mediumBig">{{userData.name}}</span>, вы отменили запись</p>
                <p class=""> в резерве.</p>

            </div>
            <div class="flex justify-center text-center flex-col  p-auto text-sm" v-if="cancel_type==='reg'">
                <p class="pt-4 font-bold"><span class="text-brand-light font-mediumBig">{{userData.name}}</span>, ваша заявка отменена.</p>
                <p class="pt-4">Ждем вас на следующих играх!</p>

            </div>
        </div>
    </modal>
</template>

<script>
import Modal from '@/views/modals/base-modal';

export default {
  name: 'ReserveThankYou',
  components: { Modal },
  props: ['cancel_type'],
  data() {
    return {
      ext: '',
      show: true,
    };
  },
  methods: {
    dismiss() {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
      this.$emit('close');
      return this.show === false;
    },
  },
  computed: {
    userData() {
      return this.$store.getters.userInfo;
    },
  },
  created() {
    const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollWidth}px`;
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },
};

</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        padding: 2rem;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .modal {
        width: 27rem;
        height: 13rem;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 5px 15px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        background-color: #ffffff;
    }

</style>
